// import { Button } from 'reactstrap';
import { ButtonBase } from '@material-ui/core';
import './index.scss'

// example >>> <ButtonCommon title="abc" />

const ButtonCommon = (props) => {
	return (
       <ButtonBase {...props} >{props.title}</ButtonBase>
	)
}

export default ButtonCommon;